import * as React from "react";

import {H1} from "@blueprintjs/core";
import * as moment from "moment";

const timeModifierAmount = 10;

interface Props {
  duration: number;
  onChange: any;
  startTime: number;
  resetTimer: number;
  timeModifier: number;
  pause: boolean;
}

export default class Timer extends React.Component<Props, {}> {
	public state = {
		duration: this.props.duration,
		startTime: moment().add(this.props.startTime, "seconds"),
		lastIterationTime: moment(),
	};
	private interval: any;
	constructor(props: any) {
		super(props);
	}

	public componentDidMount() {
		this.setState({
			startTime: moment().subtract(this.props.startTime, "seconds"),
			lastIterationTime: moment(),
		});
		this.interval = setInterval(() => {
			const newDuration = Math.round(
				this.props.duration -
					moment().diff(this.state.startTime, "seconds", true)
			);

			if (!this.props.pause) {
				this.setState({ duration: newDuration });
				this.props.onChange(newDuration);
			} else {
				// tslint:disable-next-line:no-console
				this.setState({
					startTime: this.state.startTime.add(
						moment().diff(this.state.lastIterationTime, "seconds", true),
						"seconds"
					),
				});
			}
			this.setState({ lastIterationTime: moment() });
		}, 500);
	}

	public componentWillReceiveProps(newProps: Props) {
		if (newProps.resetTimer > this.props.resetTimer) {
			this.setState({ startTime: moment() });
		}
		const timeModiferDifference =
			newProps.timeModifier - this.props.timeModifier;
		if (timeModiferDifference) {
			// tslint:disable-next-line:no-console
			console.log(
				this.state.startTime.unix() -
					moment().unix() +
					timeModiferDifference * timeModifierAmount
			);
			if (
				timeModiferDifference > 0 ||
				this.state.startTime.unix() <
					moment().unix() + timeModiferDifference * timeModifierAmount
			) {
				this.setState({
					startTime: this.state.startTime.add(
						-timeModiferDifference * timeModifierAmount,
						"seconds"
					),
				});
			} else {
				this.setState({ startTime: moment() });
			}
		}
	}

	public componentWillUnmount() {
		clearInterval(this.interval);
		this.setState({ startTime: 0 });
	}

	public render() {
		return (
			<div>
				<H1>
					{Math.trunc(this.state.duration / 60) +
						" Minutes " +
						(this.state.duration % 60) +
						" Seconds"}
				</H1>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/FightRoom/Timer.tsx